export class Organizador {
  public id: number;
  public descripcion = '';
  public codigoAlterno?;
}

export class Asamblea {
  public id: number;
  public organizador: Organizador = new Organizador();
  public tipoParticipante: number;
  public tipoEnvio: number;
  public fechaInicio: Date = new Date();
  public fechaFin: Date;
  public estado = 'PENDIENTE';
  public tiempoAsignado: number = Math.floor(0);
}
